import { Loan } from './loan-object.js';
import { getAppBridge } from './utils.js';

let appBridge = null;
let loanObj = null;

const setupCreditService = async () => {
  document
    .getElementById('getCreditScore')
    .addEventListener('click', async () => {
      await appBridge.openApp({
        id: 'creditservice',
        frameOptions: {
          containerId: 'aside-container',
          title: 'Credit Service Corp',
        },
      });
    });
};

const setupPricingService = async () => {
  await appBridge.openApp({
    id: 'pricingservice',
    frameOptions: {
      containerId: 'aside-container',
      title: 'Pricing Service Corp',
    },
  });
};

const setupLoanValidationService = async () => {
  await appBridge.openApp({
    id: 'loanvalidation',
    frameOptions: {
      containerId: 'aside-container',
      title: 'Loan Validation Service Corp',
    },
  });
};

const setupLoanObject = () => {
  loanObj = new Loan();
  appBridge.addScriptingObject(loanObj);
};

const saveLoan = async () => {
  const loanDetails = loanObj.getLoanDetails();
  const results = await appBridge.dispatchEvent({
    event: loanObj.onPreSave,
    eventParams: loanDetails,
    eventOptions: { timeout : 5000 },
  });
  if (results.some((result) => result === false)) {
    const errorFeedback = document.getElementById('errorFeedback');
    errorFeedback.classList.remove('hidden');
  } else {
    const successFeedback = document.getElementById('successFeedback');
    successFeedback.classList.remove('hidden');
  }
};

const init = async () => {
  appBridge = await getAppBridge();
  setupLoanObject();
  setupPricingService();
  setupCreditService();
  setupLoanValidationService();
  const saveLoanButton = document.getElementById('saveLoan');
  if (saveLoanButton) saveLoanButton.addEventListener('click', saveLoan);
};

window.addEventListener('DOMContentLoaded', init);
